'use client';

import React from 'react';
import Footer, { Props as FooterProps } from 'components/commercetools-ui/organisms/footer';
import { TasticProps } from '../types';
import {
  AGPerks,
  FooterData,
  FooterSection,
  StoreOpeningHours,
} from 'components/commercetools-ui/organisms/footer/types';
import { Reference } from 'types/reference';

interface FooterLink {
  name: string;
  reference: Reference;
}

interface Props extends FooterProps {
  headerCol1: string;
  linksCol1: FooterLink[];
  headerCol2: string;
  linksCol2: FooterLink[];
  headerCol3: string;
  linksCol3: FooterLink[];
  headerCol4: string;
  linksCol4: FooterLink[];
  headerCol5: string;
  linksCol5: FooterLink[];
  headerCol6: string;
  linksCol6: FooterLink[];
  weekdays: string;
  saturday: string;
  sunday: string;
  freeUKStandardDelivery: string;
  flexibleDeliveryOptions: string;
  returnPolicy: string;
  secureCheckout: string;
  data?: FooterData;
}

const FooterTastic = ({ data }: TasticProps<Props>) => {
  const footerLinks = data?.data?.dataSource?.footerlinks;

  const columns = footerLinks?.filter(
    (item) => item?.name && ['About us', 'Expert Help', 'Stores & Services', 'Ordering'].includes(item.name),
  ) as FooterSection[];

  const getGroupedData = (name: string) => footerLinks?.find((item: FooterSection) => item.name === name);

  return (
    <div className="fixed-screen-width lg:relative-width">
      <Footer
        {...data}
        columns={columns}
        cartCheckoutData={getGroupedData('HELP')}
        contactData={getGroupedData('Contact us')}
        storeOpeningHours={getGroupedData('store Opening Hours') as StoreOpeningHours}
        agPerks={getGroupedData('AG Perks') as AGPerks}
      />
    </div>
  );
};

export default FooterTastic;
